import { IHttpClient } from '@wix/http-client';
import type { EcomPlatformViewerScriptContext } from '../../../viewer-script/types';
import type { DeliveryOptionsService } from '@wix/delivery-section-checkout/services';
import type { ErrorHandlerPublicAPI } from '@wix/error-handler';
import { getFormattingLanguage } from '../../../utils/getFormattingFunction';

export function createDeliveryOptionsServiceGetter(
  locale: string,
  httpClient: IHttpClient,
  context: EcomPlatformViewerScriptContext,
  errorHandler: ErrorHandlerPublicAPI,
): () => Promise<DeliveryOptionsService> {
  let serviceInstance: DeliveryOptionsService | null = null;
  return async () => {
    /* istanbul ignore else */
    if (!serviceInstance) {
      const { DeliveryOptionsService } = await import(
        '@wix/delivery-section-checkout/services'
      );
      serviceInstance = new DeliveryOptionsService({
        translationLang: locale,
        locale: getFormattingLanguage(context.wixApi!),
        httpClient,
        timezone: context.wixApi!.site.timezone,
        experiments: context.platformServices!.essentials.experiments,
        errorHandler,
      });
    }
    return serviceInstance;
  };
}
